<template>
  <div id="app" class="pdfviewer-0001">
    <el-container>
      <el-header class="div-header">
        <Header />
        <el-divider class="header-divider"></el-divider>
      </el-header>
      <div class = "printLoaderArea" v-if="getPdfSuccessStatus != 1 && getpdf_error_status != 1">
        <div class = "printLoaderAreainner">
          <span class="printSpinner"></span>
          原文準備中...
        </div>
      </div>
      <div else>
        <div class="main-div">
          <el-container class="main-div parentDiv">
            <!-- 2021/11/19  #12251  START -->
            <div class="SID0008_DilaogDiv" v-loading.fullscreen.lock="fullscreenLoading">
                <section>
                    <el-dialog title=""
                        :visible.sync="getDialogFlag"
                        close="false"
                        :close-on-click-modal="false"
                        class="SID0009_DilaogDiv PrintHideArea">
                        <el-container>
                          <div class="SID0009__popupScreen3">
                              <div class="FirstSpan3">
                                  <span>要求された記事は表示できません。</span>
                              </div>  
                              <div class="ButtonClose3">
                                  <el-button type="info" plain @click="goBack()">閉じる</el-button>
                              </div>
                          </div>
                        </el-container>
                    </el-dialog>
                </section>
            </div>
            <!-- 2021/11/19  #12251  END -->
            <div>
              <span>画面を閉じる</span>
              <el-row class="Button0022Align">
                  <el-button class="button-0022" @click="goBack()" type="info" plain >閉じる </el-button>
              </el-row>
            </div>
          </el-container>
        </div>
      </div>
      <el-container class="footer-div">
        <el-footer class="footer-element">
          <FooterComponent />
        </el-footer>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import router from "../router";
import { mapGetters } from "vuex";
import Header from "./common/header.vue";
import FooterComponent from "./common/footerComponent.vue";
import Vue from "vue";
export default {
  name: 'Home',
  components: {
    Header,
    FooterComponent,
  },
  computed: {
    ...mapGetters("situation0004", [
        "getPdfSuccessStatus",
        // 2021/11/19  #12251  START
        "getDialogFlag",
        // 2021/11/19  #12251  END
        "getpdf_error_status"
    ]),
  // 2021/12/1  #12329  START
    ...mapGetters("situation0001", [
        "getCompanyConfigurationInfo"
    ])
  // 2021/12/1  #12329  END
	},
  // 2021/11/19  #12251  START
  data() {
		return {
      fullscreenLoading: false
		};
	},
  // 2021/11/19  #12251  END
  // 2021/12/1  #12329  START
  mounted() {
    var printArticlesCount = Vue.prototype.$session.get('printArticlesCount');
    var collective_demand_max_count = 50;
    var company_configuration_info = this.getCompanyConfigurationInfo;

    for(var s=0;s<company_configuration_info.length;s++)
    {
      if(company_configuration_info[s].configuration_key == "COLLECTIVE_DEMAND_MAX_COUNT")
      {
        collective_demand_max_count = company_configuration_info[s].configuration_value;
      }
    }
    if(collective_demand_max_count < printArticlesCount){
      this.$alert("1回に表示できる記事の上限値を超えています。","確認", {
            confirmButtonText: 'OK',
          });
    }
    
  },
  // 2021/12/1  #12329  END
  methods: {
    goBack(){
      // 2021/11/19  #12251  START
      //window.close();
      router.push('/0002');
      // 2021/11/19  #12251  END
    }
  }
}
</script>
// 2021/11/19  #12251  START
<style scoped>
@import "0008/0008.css";
@import "0009/0009.css";
</style>
// 2021/11/19  #12251  END
<style scoped>
.pdfviewer-0001 .parentDiv{
  display:block;
}
.pdfviewer-0001 .parentDiv span{
  display:block;
  padding:10px;
}
.pdfviewer-0001 .printLoaderArea{
    font-family:sans-serif;
    display:table;
    text-align:center;
    font-weight:300;
    font-size:30px;
    left:0;
    top:0;
    position:fixed;
    z-index: 9990;
    color: #0460B5;
    width: 100%;
    height: 100%;
    background-color:rgba(255, 255, 255, .9);
    transition: opacity .3s ease;
}
.pdfviewer-0001 .printLoaderAreainner {
    display:table-cell; 
    vertical-align:middle; 
    padding-bottom:100px;
}
.pdfviewer-0001 .printModal {
	font-family: sans-serif;
	display: flex;
	text-align: center;
	font-weight: 300;
	font-size: 30px;
	left: 0;
	top: 0;
	position: absolute;
	color: #045fb4;
	width: 100%;
	height: 100%;
	background-color: hsla(0, 0%, 100%, .9)
}
.pdfviewer-0001 .printClose {
	position: absolute;
	right: 10px;
	top: 10px
}
.pdfviewer-0001 .printClose:before {
	content: "\00D7";
	font-family: Helvetica Neue, sans-serif;
	font-weight: 100;
	line-height: 1px;
	padding-top: .5em;
	display: block;
	font-size: 2em;
	text-indent: 1px;
	overflow: hidden;
	height: 1.25em;
	width: 1.25em;
	text-align: center;
	cursor: pointer
}
.pdfviewer-0001 .printSpinner {
	margin-top: 3px;
	margin-left: -40px;
	position: absolute;
	display: inline-block;
	width: 25px;
	height: 25px;
	border: 2px solid #045fb4;
	border-radius: 50%;
	animation: spin .75s linear infinite
}
.pdfviewer-0001 .printSpinner:after,
.pdfviewer-0001 .printSpinner:before {
	left: -2px;
	top: -2px;
	display: none;
	position: absolute;
	content: "";
	width: inherit;
	height: inherit;
	border: inherit;
	border-radius: inherit
}
.pdfviewer-0001 .printSpinner,
.pdfviewer-0001 .printSpinner:after,
.pdfviewer-0001 .printSpinner:before {
	display: inline-block;
	border-color: #045fb4 transparent transparent;
	animation-duration: 1.2s
}
.pdfviewer-0001 .printSpinner:before {
	transform: rotate(120deg)
}
.pdfviewer-0001 .printSpinner:after {
	transform: rotate(240deg)
}
@keyframes spin {
	0% {
		transform: rotate(0deg)
	}
	to {
		transform: rotate(1turn)
	}
}
</style>